import useAppStore from "@/Modules/App/Store";

import type { TherapistStore } from "@/Modules/Therapist/Store";
import type { AppStore } from "@/Modules/App/Store";
import type { TherapistCreateEducationApiQuery } from "@/Modules/Models/Api/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import TherapistApiConnector from "@/Services/TherapyApi/Therapists";
import type { TherapistEducation } from "@/Modules/Models/Domain/Therapist";

class CreateEducationActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly appStore: AppStore = useAppStore(),
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle(createEducationApiQuery: TherapistCreateEducationApiQuery) {
    try {
      this.therapistStore.isLoading = true;

      const eduApi = await this.therapistApiConnector.createTherapistEducation(createEducationApiQuery);

      const education: TherapistEducation = {
        uuid: eduApi.uuid,
        title: eduApi.title,
        institution: eduApi.institution,
      };

      if (this.therapistStore.therapist?.educations.length) {
        this.therapistStore.therapist.educations = [education, ...this.therapistStore.therapist.educations];
      } else {
        this.therapistStore.therapist?.educations.push(education);
      }

      this.appStore.showSnackbar({
        type: NotificationType.SUCCESS,
        message: "settings.configuration.educations.notification.create.success",
      });
    } catch (error: unknown) {
      this.appStore.showSnackbar({
        type: NotificationType.ERROR,
        message: "settings.configuration.educations.notification.error",
      });
    } finally {
      this.therapistStore.isLoading = false;
    }
  }
}

export default CreateEducationActionHandler;
